import type { Locale } from '@agapi/mlc-core/src/types/general';

export interface Loop54ClientConfig extends Record<string, unknown> {
  fetch: typeof globalThis.fetch;
  apiKeys: Record<string, string>;
  apiUrls: Record<string, string>;
  marketIds: Record<string, string>;
}

export const getClient = async <T = Response>(
  f: typeof globalThis.fetch,
  locale: Locale,
  params: {
    path: string;
    body: Record<string, unknown>;
    userId?: string;
    config: Loop54ClientConfig;
  }
) => {
  const { path, body, userId, config } = params;
  const headers: Record<string, string> = {
    'Content-Type': 'json/application',
    'Api-Version': 'V3',
    ...(config.apiKeys[locale.language] && { 'Loop54-key': config.apiKeys[locale.language] }),
    'User-Id': userId || 'unknown'
  };

  const url = `${config.apiUrls[locale.language]}/${path}`;

  /*
  console.log('loop54', url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  });
  */

  // const f = typeof fetch === 'undefined' ? (await import('node-fetch')).default : fetch;
  const response = await f(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  });

  const data: any = await response.json();
  if (!response.ok) {
    // console.error(data.error);
    throw new Error(`[${data.error.code}]: ${data.error.detail}`);
  }
  return data as T;
};
